import getConfirmedServiceWithUpgrades from './getConfirmedServiceWithUpgrades';
import getOtherServicesAvailable from './getOtherServicesAvailable';
import AppState from '../AppState';
/**
 * Filter options according to OptionTypes, and ensure PlanIdentifiers are unique.
 *
 * @param {AvailableSelections[]} options - The available selections to filter.
 * @param {...number[]} values - The values to filter options against.
 * @returns {AvailableSelections[]} - The filtered options.
 */
const filterOptions = (options, ...values) => {
    const uniquePlanIdentifiers = new Set();
    return options.filter(item => {
        const { PlanIdentifier, OptionType } = item;
        if (!uniquePlanIdentifiers.has(PlanIdentifier)) {
            uniquePlanIdentifiers.add(PlanIdentifier);
            return values.some(val => OptionType === val);
        }
        return false;
    });
};
/**
 * Determines if there is a plan available for the entered address. Triggers
 * "Service Unavailable" block or continues with journey.
 */
const getServicesAvailable = () => {
    const planId = AppState.get('planId');
    const mutableOptions = AppState.get('mutableOptions');
    const addressCheckProgress = AppState.get('addressCheckProgress');
    const availablePlans = filterOptions(mutableOptions, 9, 23);
    addressCheckProgress.style.display = 'none';
    // No upgrades available for this address.
    if (!availablePlans.find(item => item.PlanIdentifier === planId)) {
        getOtherServicesAvailable(availablePlans);
    }
    // Upgrades available for this address.
    else {
        getConfirmedServiceWithUpgrades(availablePlans);
    }
};
export default getServicesAvailable;
